import {useState, useEffect} from 'react'
import axios from 'axios'
import ListPromo from '../components/ListPromo'
import InfiniteScroll from "react-infinite-scroll-component";
import CardLoading from '../components/CardLoading';
import { Container, Row, Button } from 'reactstrap'
import {useLocation, useHistory} from 'react-router-dom'
import Filter from '../components/Filter';
import NotFound from '../components/NotFound';
import Paginator from '../helper/Paginator'
import jsonQuery from 'json-query'
import SlidingHighlights from '../components/SlidingHighlights';
import SlidingHero from '../components/SlidingHero';

import _ from 'lodash'
import GetCurrentLang from '../helper/GetCurrentLang';

declare global {
  interface Window {
    dataLayer: any
  }
}

interface PaginationTypes {
  data: any[],
  next_page: number | null,
  page: number | null,
  per_page: number | null,
  total: number | null,
  total_pages: number
}


const Index = () => {
  const [items, setItems] = useState({
    data: [],
    page: 0
  })
  const [pagination, setPagination] = useState<PaginationTypes>({
    data: [],
    next_page: null,
    page: null,
    per_page: null,
    total: null,
    total_pages: 1
  })

  const [JSONq, setJSONq] = useState<any>([])

  function DataPagination (data : any) {
    const paginator : PaginationTypes = Paginator({
      items: _.orderBy(data.value, ['title'], (sortFilter === 'asc') ? 'asc' : 'desc'),
      current_page: items.page,
      per_page_items: 12
    })
    return paginator
  }


  useEffect(() => {
    fetchMoreData()
  }, [pagination])
  
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery()
  const history = useHistory() 

  const queryCategory = query.get('category')
  const queryCity = query.get('city')
  const querySort : string | null = query.get('sort')
  const queryKeyword = query.get('search')

  const [categoryFilter, setCategoryFilter] = useState<any[]>((queryCategory !== null) ? queryCategory.split(',') : [])
  const [cityFilter, setCityFilter] = useState<any[]>((queryCity !== null) ? queryCity.split(',') : [])
  const [sortFilter, setSortFilter] = useState<string>((querySort !== null) ? querySort : 'asc')
  const [querySearch, setQuerySearch] = useState((queryKeyword !== null) ? queryKeyword : '')
  const [hasMore, setHasMore] = useState(true)
  const [notFound, setNotFound] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [cities, setCities] = useState([])
  const [fetchStart, setFetchStart] = useState(false)
  const per_page = 8


  let location = useLocation();


  let qString = function (filter : string[], type : string) : string {
    let catString : string = ''
    filter.map((cat) => {
      const taxonomy = (type === 'category' ? categories : cities)
      let filter : any = taxonomy.filter(category => category.object_id === cat)
      catString += `${type === 'category' ? 'categories=' : 'tags~'}${filter[0].object_id}|`
    }) 
    return catString.slice(0, -1)
  }

  

  useEffect(() => {
    // Get Categories
    axios.get(process.env.PUBLIC_URL + `/data/menu-24-${GetCurrentLang()}.json`)
    .then((res) => {
      setCategories(res.data[0].items)
      axios.get(process.env.PUBLIC_URL + `/data/menu-30-${GetCurrentLang()}.json`)
      .then((res) => {
        setCities(res.data[0].items)
        setFetchStart(true)
      })
    })
  },[])

  useEffect(() => {
    if(fetchStart) {
      axios.get(`${process.env.PUBLIC_URL}/data/posts-${GetCurrentLang()}.json`)
      .then(resp => {
        
        const filter = qString(categoryFilter, 'category') + ((categoryFilter.length > 0 && cityFilter.length > 0) ? '&' : '')+ qString(cityFilter, 'city');
        const json = jsonQuery(`[**][*${filter}]`, {
          data: resp.data,
          allowRegexp: true
        })
        if(querySearch !== '') {
          const q = qSearch(json.value)
          setJSONq(q)
          setPagination(DataPagination(q))
        }else {
          setJSONq(json)
          setPagination(DataPagination(json))
        }
      })
    }
  }, [fetchStart, queryCategory, queryCity, querySearch])

  let qSearch = function(posts : any) {
    let result: any[] = []
    posts.forEach(function(o: any){
      o.title.rendered && o.title.rendered.toLowerCase().indexOf(querySearch.toLowerCase()) >= 0 && result.push(o)
    });
    return {value: result}
  }

  function resetItems() {
    setItems({
      data: [],
      page: 1
    })
    setHasMore(true)
  }

  function removeFilter() {
    setCategoryFilter([])
    setCityFilter([])
  }

  const fetchMoreData = () => {
    const total_pages = pagination.total_pages
    const paginator = DataPagination(JSONq)
    if(items.page === total_pages) {
      setHasMore(false)
    }
    if(total_pages > 0) {
      setTimeout(() => {
        setItems((prevItems) => {
          let item : any = (items.page > 1) ? prevItems : { data : []}
          const newData = item.data.concat(paginator.data)
          return {
            data: newData,
            page: prevItems.page + 1
          }
        })
      }, (items.page > 1) ? 1000 : 0)
      setNotFound(false)
    }else {
      setNotFound(true)
    }
  }


  const filterCategory = (category: any) => {
    const checkIfExist = categoryFilter.includes(category);
    if(checkIfExist) {
      setCategoryFilter(categoryFilter.filter((e)=>(e !== category)))
    }else {
      setCategoryFilter([...categoryFilter, category])
    }
  }

  const filterCity = (city: any) => {
    const checkIfExist = cityFilter.includes(city);
    if(checkIfExist) {
      setCityFilter(cityFilter.filter((e)=>(e !== city)))
    }else {
      setCityFilter([...cityFilter, city])
    }
  }


  const filterSubmit = () => {
    setQuerySearch('')
    resetItems()
    window.dataLayer.push({
      'event': 'filter' ,
      'filter_detail': `${categoryFilter.join()} ${(cityFilter.length > 0) ? `| ${cityFilter.join()}` : ''}`
    });
    history.push({
      pathname: '/',
      search: `${(categoryFilter.length > 0) ? `category=${categoryFilter.join()}` : ''}${(cityFilter.length > 0) ? `&city=${cityFilter.join()}` : ''}`
    })
  }


  const searchSubmit = (query : string) => {
    resetItems()
    removeFilter()
    setQuerySearch((query === null) ? '' : query)
    history.push({
      pathname: '/',
      search: (query === null) ? '' : `search=${query}`
    })
  }

  const resetFilter = () => {
    resetItems()
    setQuerySearch('')
    removeFilter()
    history.push({
      pathname: '/',
      search: ''
    })
  }

  function TotalLoader() {
    const getWindowWidth = window.innerWidth
    let total = per_page
    if(getWindowWidth > 768 && getWindowWidth < 992) {
      total = 2
    }else if(getWindowWidth < 768) {
      total = 1
    }
    return total
  }

  const loading = (
    <Row>
      {Array.apply(0, Array(TotalLoader()) ).map(function (x, i) {
        return <div className="ColPromo" key={i}><CardLoading /></div>
      })}
    </Row>
  )

  const isHomePage = () => {
    return (location.pathname === '/' && location.search === "")
  }

  return (
    <>
      <div className="pt-4 bg-light-blue">
        <Container>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-end header-index">
            <h1 className="mt-0 mb-4 mb-lg-0" style={{ fontSize: '3.4rem' }}>BCA Year End Salebration</h1>
            <Filter 
              categories={categories}
              cities={cities}
              filterCategory={filterCategory} 
              categoryFilter={categoryFilter} 
              filterSubmit={filterSubmit}
              resetFilter={resetFilter}
              filterCity={filterCity}
              cityFilter={cityFilter}
              searchSubmit={searchSubmit}
              queryKeyword={querySearch}
            />
          </div>
        </Container>
      </div>
      <div className="white-section">
        <Container>
        {(location.pathname === '/' && location.search === "") && (
            <>
              <SlidingHero />
              <SlidingHighlights resetFilter={resetFilter} setCategoryFilter={setCategoryFilter}/>
            </>
          )}
          {!notFound ? (
            (pagination.data.length > 0) && (
              <InfiniteScroll
                  dataLength={items.data.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  loader={loading}
                  scrollThreshold={0.7}
                >
                  <ListPromo {...items}/>
              </InfiniteScroll>
            )
          ) : (
            <NotFound />
          )}
          {(!isHomePage()) && (
            <div className="text-center">
              <Button color="primary" onClick={() => resetFilter()}>Kembali ke Halaman Promo</Button>
            </div>
          )}
        </Container>
      </div>
    </>
  )
}

export default Index
